import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useDialogStore } from '@stores/dialog.store'

import type { DialogBtn } from './Dialog'

interface Props {
  dialogName: string
  okBtn?: DialogBtn
  cancelBtn?: DialogBtn
  destructive?: boolean
}

const DialogButtons: React.FC<Props> = ({ dialogName, okBtn, cancelBtn, destructive }: Props) => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)

  return (
    <div
      className={classNames(
        'flex w-full mt-5',
        destructive ? 'flex-row-reverse justify-start' : 'flex-row justify-end'
      )}>
      {cancelBtn && (
        <button
          type="button"
          className="ml-3 btn btn-secondary"
          onClick={
            typeof cancelBtn === 'object' && cancelBtn.action
              ? cancelBtn.action
              : () => closeDialog(dialogName)
          }>
          {typeof cancelBtn === 'object' && cancelBtn.text ? cancelBtn.text : t('action.cancel')}
        </button>
      )}
      {okBtn && (
        <button
          type="button"
          className="ml-3 btn btn-primary"
          disabled={typeof okBtn === 'object' && okBtn.disabled}
          onClick={
            typeof okBtn === 'object' && okBtn.action ? okBtn.action : () => closeDialog(dialogName)
          }>
          {typeof okBtn === 'object' && okBtn.text ? okBtn.text : t('action.ok')}
        </button>
      )}
    </div>
  )
}

export default DialogButtons
